module.exports = __webpack_public_path__ + "img/benefit-icon_email.93e49cae.svg";